import { useSingleImageEffect } from '@/src/components/Upload';
import { get, last } from 'lodash';
import React from 'react';
import { useParams } from 'react-router';
import {
  Form,
  FormItemLinkModule,
  Input,
  ModalFooter,
  OriSelect,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import {
  Item as ItemWrapper,
  ModalContent,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Uploader } from 'src/components/Upload';
import { ESocialMediaType } from 'src/types/common/SalesChannel';
import css from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { EType } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import { onFinishFailed } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { LinkModuleType } from 'src/types/common/linkType';
const Item = Form.Item;
const Option = OriSelect.Option;

const SocialMediaEditor = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const name = 'socialMediaForm';
  const [form] = Form.useForm();
  const { data, mediaList, onCancel, onConfirm, isPrimary } = props;
  const _mediaList = React.useMemo(() => {
    const hasOther = (mediaList || []).find(
      (i) => i.mediaType === ESocialMediaType.Other,
    );
    if (hasOther) {
      return mediaList || [];
    }
    return [...mediaList, { mediaType: ESocialMediaType.Other }];
  }, [mediaList]);

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, []);

  const handleOnError = (error) => {
    onFinishFailed(name, error);
    return false;
  };

  const handleOnFinish = (v) => {
    const _data = { ...(data || {}), ...v };
    onConfirm(_data);
    onCancel();
  };

  const params: any = useParams();

  const { contentUuid } = params;

  //const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });

  return (
    <React.Fragment>
      <Form
        name={name}
        form={form}
        onFinishFailed={handleOnError}
        onFinish={handleOnFinish}>
        <ModalContent>
          <Section className={css.section}>
            {isPrimary && (
              <ItemWrapper
                title={getI18n('salesChannelContent.index.socialMediaType')}
                id='footerMediaType'>
                <Item name='mediaType'>
                  <OriSelect
                    size='large'
                    // getPopupContainer={() => {
                    //   return document.getElementById('footerMediaType');
                    // }}
                  >
                    {_mediaList.map((i) => {
                      const { mediaType } = i;
                      return (
                        <Option value={mediaType} key={mediaType}>
                          {mediaType}
                        </Option>
                      );
                    })}
                  </OriSelect>
                </Item>
              </ItemWrapper>
            )}

            <Item
              shouldUpdate={(p, c) => {
                const pV = get(p, 'mediaType');
                const cV = get(c, 'mediaType');
                return cV !== pV;
              }}>
              {(f) => {
                const { getFieldValue } = f;
                const type = getFieldValue('mediaType');
                if (type === ESocialMediaType.Wechat) {
                  return generateWechat({ getI18n });
                }
                if (type === ESocialMediaType.FaceBook) {
                  return generateExternalLink(
                    `${getI18n('salesChannelContent.index.facebookLink')}*`,
                    contentUuid,
                    { getI18n },
                  );
                }
                if (type === ESocialMediaType.Instagram) {
                  return generateExternalLink(
                    `${getI18n('salesChannelContent.index.instagramLink')}*`,
                    contentUuid,
                    { getI18n },
                  );
                }
                if (type === ESocialMediaType.Weibo) {
                  return generateExternalLink(
                    `${getI18n('salesChannelContent.index.weiboLink')}*`,
                    contentUuid,
                    { getI18n },
                  );
                }
                if (type === ESocialMediaType.Twitter) {
                  return generateExternalLink(
                    `${getI18n('salesChannelContent.index.twitterLink')}*`,
                    contentUuid,
                    { getI18n },
                  );
                }
                if (type === ESocialMediaType.Other) {
                  return generateOther(isPrimary, { getI18n });
                }
              }}
            </Item>
          </Section>
        </ModalContent>
        <ModalFooter
          onCancel={onCancel}
          onOk={() => {
            form.submit();
          }}
        />
      </Form>
    </React.Fragment>
  );
};

export default SocialMediaEditor;

const generateOther = (isPrimary, { getI18n }) => {
  return (
    <React.Fragment>
      {isPrimary && (
        <ItemWrapper
          title={`${getI18n('salesChannelContent.index.socialMediaName')}*`}>
          <Input
            size='large'
            maxLength={100}
            formProps={{
              name: 'mediaName',
              rules: [
                {
                  required: true,
                  message: getI18n('general.commonAmount.pleasefilltheinput'),
                },
              ],
            }}
          />
        </ItemWrapper>
      )}

      <ItemWrapper
        title={`${getI18n('salesChannelContent.index.socialMediaIcon')}*`}
        bottomTitle={`${getI18n(
          'salesChannelContent.index.recommendedratio',
        )} 1:1. ${getI18n('general.allowedfiletypes')}: jpeg, png, svg, gif`}>
        <Item
          name='icon'
          rules={[
            {
              required: true,
              message: getI18n(
                'salesChannelContent.index.pleaseuploadtheimage',
              ),
            },
          ]}>
          <Image />
        </Item>
      </ItemWrapper>
      {isPrimary && (
        <ItemWrapper
          title={getI18n('salesChannelContent.index.linkToSocialMediaVia')}>
          <Item name='refType'>
            <RadioGroup className={css.groupContainer}>
              <RadioItem value={EType.URL_LINK} className={css.radio}>
                {getI18n('salesChannelContent.index.uRLLink')}
              </RadioItem>
              <RadioItem value={EType.QR_CODE}>
                {getI18n('general.qRcode')}
              </RadioItem>
            </RadioGroup>
          </Item>
        </ItemWrapper>
      )}

      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, 'refType');
          const cV = get(c, 'refType');
          return cV !== pV;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const type = getFieldValue('refType');
          if (type === EType.URL_LINK) {
            return (
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelContent.index.socialMediaURLLink',
                )}*`}>
                <Input
                  size='large'
                  maxLength={300}
                  formProps={{
                    name: 'refUrl',
                    rules: [
                      {
                        required: true,
                        message: getI18n(
                          'general.commonAmount.pleasefilltheinput',
                        ),
                      },
                    ],
                  }}
                />
              </ItemWrapper>
            );
          }
          if (type === EType.QR_CODE) {
            return (
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelContent.index.socialMediaQRCode',
                )}*`}
                bottomTitle={`${getI18n(
                  'salesChannelContent.index.recommendedsize',
                )} 360px * 410px, ${getI18n(
                  'salesChannelContent.index.maximumheight',
                )} 480px. ${getI18n(
                  'general.allowedfiletypes',
                )}: jpeg, png, svg, gif`}>
                <Item
                  name='refImage'
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'salesChannelContent.index.pleaseuploadtheimage',
                      ),
                    },
                  ]}>
                  <Image />
                </Item>
              </ItemWrapper>
            );
          }
        }}
      </Item>
    </React.Fragment>
  );
};

const generateWechat = ({ getI18n }) => {
  return (
    <ItemWrapper
      title={`${getI18n('salesChannelContent.index.wechatQRCode')}*`}
      bottomTitle={`${getI18n(
        'salesChannelContent.index.recommendedsize',
      )} 360px * 410px, ${getI18n(
        'salesChannelContent.index.maximumheight',
      )} 480px. ${getI18n('general.allowedfiletypes')}: jpeg, png, svg, gif`}>
      <Item
        name='icon'
        rules={[
          {
            required: true,
            message: getI18n('general.commonAmount.pleasefilltheinput'),
          },
        ]}>
        <Image />
      </Item>
    </ItemWrapper>
  );
};

const generateExternalLink = (title, contentUuid, { getI18n }) => {
  return (
    <ItemWrapper title={title}>
      <Item
        name='linkLibraryVO'
        rules={[
          {
            validator: async (x, value) => {
              const { linkType } = value || {};
              if (!linkType) {
                return Promise.reject(
                  new Error(
                    getI18n('salesChannelContent.index.pleasefillLink'),
                  ),
                );
              }
            },
          },
        ]}>
        <FormItemLinkModule
          linkSet={{
            linkTypeFilter: [LinkModuleType.LinkLibrary],
            scopeVariables: { SalesChannelContent: contentUuid },
          }}
        />
      </Item>
    </ItemWrapper>
  );
};

// const Link = (props) => {
//   const { onChange, value, id ,linkProps} = props;
//   const [link, setLink] = React.useState(value);
//   React.useEffect(() => {
//     if (!isEqual(value, link)) {
//       setLink(value);
//     }
//   }, [value]);

//   const onLinkChange = (l) => {
//     setLink(l);
//     onChange(l);
//   };
// const params: any = useParams();

// const { saleChannelUuid } = params;
//   //console.log('params', params);
//   return (
//     <LinkLibrary
//       //   error={linkTypeErrorArray
//       //     .map((err) => (errCodesMap[err] ? errCodesMap[err] : err))
//       //     .join('')}
//       //mode={'no-modal'}
//       noWrapper
//       data={link || {}}
//       onChange={onLinkChange}
//       id={id}
// linkSet={{
//   linkTypeFilter: [LinkModuleType.LinkLibrary],
//   scopeVariables: { SalesChannel: saleChannelUuid },
// }}
//     />
//   );
// };

const Image = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onChange, value: linkImage, id } = props;
  const [fileList, setFileList] = React.useState(linkImage ? [linkImage] : []);
  useSingleImageEffect(linkImage, fileList, setFileList);
  return (
    <div id={id} style={{ width: 180 }}>
      <Uploader
        btnText={getI18n('general.selectFiles')}
        height={180}
        multiple={false}
        fileList={fileList}
        onChange={(imgArr = []) => {
          setFileList(imgArr);
          if (onChange) {
            const _l = last(imgArr);
            onChange(_l);
          }
        }}
      />
    </div>
  );
};
